/**
 * Converts top-down ImageData (Canvas 2D) to bottom-up RGBA bytes matching WebGL readPixels layout.
 */
export function imageDataToGlPixels(imageData: ImageData): Uint8Array {
  const { width, height, data } = imageData;
  const pixelData = new Uint8Array(width * height * 4);
  const bytesPerRow = width * 4;

  for (let y = 0; y < height; y += 1) {
    const srcOffset = y * bytesPerRow;
    const dstOffset = (height - y - 1) * bytesPerRow;
    pixelData.set(data.subarray(srcOffset, srcOffset + bytesPerRow), dstOffset);
  }

  return pixelData;
}

/**
 * Converts bottom-up WebGL RGBA bytes to top-down ImageData.
 */
export function glPixelsToImageData(pixelData: Uint8Array, width: number, height: number): ImageData {
  const imageData = new ImageData(width, height);
  const bytesPerRow = width * 4;

  for (let y = 0; y < height; y += 1) {
    const srcOffset = (height - y - 1) * bytesPerRow;
    const dstOffset = y * bytesPerRow;
    imageData.data.set(pixelData.subarray(srcOffset, srcOffset + bytesPerRow), dstOffset);
  }

  return imageData;
}

export function cloneImageData(imageData: ImageData): ImageData {
  const copy = new ImageData(imageData.width, imageData.height);
  copy.data.set(imageData.data);
  return copy;
}

export function createBlankImageData(width: number, height: number): ImageData {
  return new ImageData(width, height);
}

export function assertSameImageDimensions(imageA: ImageData, imageB: ImageData, operation: string): void {
  if (imageA.width !== imageB.width || imageA.height !== imageB.height) {
    throw new Error(
      `${operation}: image dimensions must match (${imageA.width}x${imageA.height} vs ${imageB.width}x${imageB.height})`
    );
  }
}
